import { IconNames } from '../../common/components/Icon/IconNames';
import { Colors } from '../../common/constants/Colors';
import { t } from '../../common/i18n';
import { IssueStatus } from '../types';

const namespace = 'Issues';

export const issueStatuses: IssueStatus[] = ['new', 'in_progress', 'resolved', 'rejected'];

/**
 * Set ikon pro kategorie – 16 položek (grid 4×4 v icon pickeru, bez mezery).
 * Jednobarevné SVG (stroke currentColor), návodné pro typické kategorie SVJ.
 * Musí odpovídat backend whitelistu IssueCategoryIconSet::ICONS.
 */
export const CATEGORY_ICON_SET: IconNames[] = [
  'wrench',
  'alertTriangle',
  'bulb',
  'broom',
  'droplet',
  'flame',
  'bolt',
  'elevator',
  'keys',
  'shieldCheck',
  'car',
  'leaf',
  'speaker',
  'house',
  'envelope',
  'infoCircle',
];

/** Ikona kategorie z API s fallbackem pro neznámou hodnotu. */
export const resolveCategoryIcon = (icon: string): IconNames =>
  CATEGORY_ICON_SET.includes(icon as IconNames) ? (icon as IconNames) : 'infoCircle';

/** Barva (color prop komponenty Text) odpovídající stavu hlášení. */
export const statusColor = (status: IssueStatus): Colors => {
  switch (status) {
    case 'new':
      return 'SystemOrange';
    case 'in_progress':
      return 'Primary600';
    case 'resolved':
      return 'SystemGreen';
    case 'rejected':
      return 'Neutral600';
  }
};

export const statusOptions = (): { value: IssueStatus; label: string }[] =>
  issueStatuses.map((status) => ({ value: status, label: t(`status.${status}`, namespace) }));
